import { breakpoints } from './breakpoints'

const BASE_FONT_SIZE = 16

export const spacing = (n: number) => n * 8

export const pxToRem = (px: number) => px / BASE_FONT_SIZE

export const getFluidSize = (baseSize: string, deltaSize = 12) =>
  `calc(${baseSize} + ${deltaSize} * ((100vw - ${breakpoints.S}) / 2816))`

export const getNegativeFluidSize = (baseSize: string) =>
  `calc( 0px - (${baseSize} + 12 * ((100vw - ${breakpoints.S}) / 2816)))`

export const fluidFontSize = `calc(12px + 12 * ((100vw - ${breakpoints.S}) / 2816))`

export const getFluidFontSize = (baseSize: string, deltaSize?: number) =>
  getFluidSize(baseSize, deltaSize)

export const getFluidSizeWithFullFormula = (
  unit: string,
  minSize: number,
  maxSize: number,
  minVW: number,
  maxVW: number,
) =>
  `calc(${minSize}${unit} + (${maxSize} - ${minSize})*((100vw - ${minVW}px)/(${maxVW} - ${minVW})))`

export const getFluidSizeWithFullFormulaNegative = (
  unit: string,
  minSize: number,
  maxSize: number,
  minVW: number,
  maxVW: number,
) =>
  `calc(-${minSize}${unit} - (${maxSize} - ${minSize})*((100vw - ${minVW}px)/(${maxVW} - ${minVW})))`

export const getFluidSizeWithFullFormulaHeight = (
  unit: string,
  minSize: number,
  maxSize: number,
  minVH: number,
  maxVH: number,
) =>
  `calc(${minSize}${unit} + (${maxSize} - ${minSize})*((100vh - ${minVH}px)/(${maxVH} - ${minVH})))`

export const getFluidFontSizeDe = (minSize: number, maxSize: number) =>
  getFluidSizeWithFullFormula('px', minSize, maxSize, 960, 1920)

export const getFlexRowFluidMaxWidthPerItems = (
  unit: string,
  minSize: number,
  maxSize: number,
  minVW: number,
  maxVW: number,
  itemsPerRow: number,
) =>
  `calc((${minSize}${unit} + (${maxSize} - ${minSize})*((100vw - ${minVW}px)/(${maxVW} - ${minVW}))) * ${itemsPerRow +
    1});`
